export default {
  loading: true,
  currentOrganisationId: '',
  list: {
    data: [],
    links: {},
    meta: {},
  },
  apiError: {},
};
